import React from "react";

import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../../providers/Auth";
import { getEncryptSessionStorage } from "../../utils/EncryptStorage";
import { isJwtExpired } from "jwt-check-expiration";

const PrivateRoute = () => {
  const auth = useAuth();

  auth.checkSessionExpired();

  const token: string = auth.currentToken() + "";

  // check if jwt token is expired
  if (token !== null && token?.length > 0) {
    if (isJwtExpired(token)) {
      const state = {
        showAlert: true,
        severity: "error",
        message: "all.alert.session-expired"
      };
      return <Navigate to="/login" replace={true} state={state} />;
    }
  }

  if (auth.loading) return <div>loading</div>;
  const sessionExpired = getEncryptSessionStorage("sessionExpired");
  const state =
    sessionExpired === "true"
      ? {
          showAlert: true,
          severity: "error",
          message: "all.alert.session-expired"
        }
      : {
          showAlert: true,
          severity: "error",
          message: "all.alert.unauthorized"
        };
  return auth?.user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace={true} state={state} />
  );
};

export default PrivateRoute;
